export default "__VITE_ASSET__CvBedLjm__"